/**
 * OpenAPI definition
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * Settlement destination
 */
export interface SettlementDestinationDto {
  id: number;
  network: string;
  address: string;
  accountId: number;
  assetId: number;
  fireblocks: boolean;
  approved: boolean;
  contract?: string;
  clientTag?: string;
  adminTag?: string;
  /**
   * Inclusive lower bound of the automated withdrawal range. Null when not automated.
   */
  minAmount?: number;
  /**
   * Inclusive upper bound of the automated withdrawal range. Null when not automated.
   */
  maxAmount?: number;
  /**
   * Bank API request params as JSON. Null when not automated.
   */
  bankApiParams?: string;
}
